module.exports = __webpack_public_path__ + "img/home_head_bg.187954ce.png";